import type {
  TGetCorretagensResponse,
  TParticipacaoImobiliariaCorretor,
} from '@/features/proposta/interfaces/proposta.type'

export class CadastroImobiliariaCorretorEntity {
  constructor(
    private readonly listaCorretagensCadastradas: TGetCorretagensResponse,
    private readonly percentualCorretagemParametrizado: number | null,
    private readonly valorCorretagemParametrizado: number | null,
  ) {}

  obterCorretagemImobiliariaCorretorSelecionada(idExterno: string) {
    const corretagem = this.listaCorretagensCadastradas.find((p) => p.idExterno === idExterno)

    const hasPercentualParametrizado = this.percentualCorretagemParametrizado !== null
    const percentual = corretagem?.percentualCorretagem
    const valor = corretagem?.valorCorretagem

    if (percentual != null || hasPercentualParametrizado) {
      return {
        tipo: 'percentual' as const,
        percentualCorretagemImobiliaria: percentual ?? this.percentualCorretagemParametrizado,
      }
    }

    const hasValorCorretagemValido = valor != null && valor >= 0
    if (hasValorCorretagemValido) {
      return {
        tipo: 'valor' as const,
        valorCorretagemImobiliaria: valor || (this.valorCorretagemParametrizado ?? 0),
      }
    }

    return {
      tipo: 'percentual' as const,
      percentualCorretagemImobiliaria: 0,
    }
  }

  get novoCadastro(): TParticipacaoImobiliariaCorretor {
    const hasPercentualParametrizado = this.percentualCorretagemParametrizado != null
    if (hasPercentualParametrizado) {
      return {
        imobiliariaCorretor: {
          descricao: '',
          idExterno: '',
          documento: '',
          tipoImobiliariaCorretor: 'Imobiliaria',
          nome: '',
        },
        corretagem: {
          tipo: 'percentual' as const,
          percentualCorretagemImobiliaria: this.percentualCorretagemParametrizado,
        },
      }
    }
    const hasValorCorretagemParametrizado = this.valorCorretagemParametrizado != null
    if (hasValorCorretagemParametrizado) {
      return {
        imobiliariaCorretor: {
          descricao: '',
          idExterno: '',
          documento: '',
          tipoImobiliariaCorretor: 'Imobiliaria',
          nome: '',
        },
        corretagem: { tipo: 'valor' as const, valorCorretagemImobiliaria: this.valorCorretagemParametrizado },
      }
    }

    return {
      imobiliariaCorretor: {
        descricao: '',
        idExterno: '',
        documento: '',
        tipoImobiliariaCorretor: 'Imobiliaria',
        nome: '',
      },
      corretagem: { tipo: 'percentual' as const, percentualCorretagemImobiliaria: 0 },
    }
  }
}
